import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import DialogComponent, { Modal } from "src/components/DialogComponent";
import Loading from "src/components/Loading";
import TabsCard from "src/modules/acadia/tabsCard";
import Card from "src/modules/acadia/card";
import VersionsCard from "src/modules/acadia/versionsCard";
import ApproversCard from "src/modules/acadia/approversCard";
import HistoryCard from "src/modules/acadia/historyCard";
import CopiesCard from "src/modules/acadia/copiesCard";
import ListsCard from "src/modules/acadia/listsCard";
import {
  ReportIcon,
  TrashIcon,
  ArchiveIcon,
  ArchiveAddIcon,
  PrinterIcon,
} from "src/components/ui-icons/card";
import {
  selectItems
} from "src/modules/spItems/selectors";
import {
  activityAnalysisListName,
  approversCardDocumentListName,
  approversDependenciesListName,
  approversListName,
  copiesCardDocumentListName,
  documentByCardFilesLibName,
  emailsSender,
  equipmentsByDocumentListName,
  favoriteDocumentsListName,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  listsApproversListName,
  myDocumentsListName,
  paramsListName,
  siteUrl,
  versionsByDocumentListName,
} from "src/api/config";
import ConfirmRemoveModal from "src/modules/acadia/confirmRemoveModal";
import ConfirmChangeStatusCardModal from "src/modules/acadia/confirmChangeStatusCardModal";
import _, { result } from "lodash";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import FavoriteButton from "../../acadia/components/FavoriteButton";
import TGTag from "src/components/ui/TGTag";
import CancelAddCard from "src/modules/acadia/addCard/components/cancel";
import { TooltipItem } from "src/utils/Tooltip";
import { myWorksDocumentsListName } from "src/api/config";
import { getWorkDocumentsInfo } from "src/modules/acadia/documents/actions";
import EditApproversModal from "src/modules/acadia/editApproversModal";
import { NotificationSendButton, useStatusContext } from "../../acadia/notificationPage";
import moment from "moment";
import SupplayButton from "src/components/Button";
import ReturnToWorkModal from "src/modules/acadia/returnToWorkModal";
import ApproveBlockModal from "src/modules/acadia/approveBlockModal";
import ArchiveConfirmModal from "src/modules/acadia/archiveConfirmModal";
import ArchiveEndModal from "src/modules/acadia/archiveEndModal";
import ReportDocumentModal from "src/modules/acadia/reportDocumentModal";
import RemoveDocumentModal from "src/modules/acadia/removeDocumentModal";
import {
  addItemRequest,
  deleteItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import { containsAllIds } from "src/constants";
import axios from "axios";
import { emailAPI } from "src/utils/api.utils";
import { setLocalItem } from "src/utils/localStorage";
import { clearDocumentCardStorage } from "src/utils/documentCardStorage";
import { addAnalysis, checkApprovers } from "src/modules/acadia/constants";
import {
  notificationIdsListName,
  notificationsCardListName,
  notificationsListName,
} from "src/api/config/notifications.config";
import { emailQueueListName } from "src/api/config/email.config";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import {
  docApprovers,
  docStatuses,
  notificationStatuses
} from "src/api/config/systemSwitch";
import { NotificationReportDrawer } from "src/components/tables/NotifyReportTableWithFilters";
import TGButton from "src/components/ui/TGButton";
import { getLatestUniqueGroups } from "src/modules/acadia/approversCard/approversCard";
import ImagesList from "src/components/ImagesList";
import { AuditNotificationIcon } from "src/components/ui-icons/card/auditNotificationIcon";
import { OwdNotificationIcon } from "src/components/ui-icons/card/owdNotificationIcon";
import { AuditSuccessIcon } from "src/components/ui-icons/card/auditSuccessIcon";

const { sendEmail } = emailAPI();

const DocumentCard = ({
  open,
  toggleDialog,
  documentCardID,
  versionView,
  closeAllModals,
  setCloseAllModals,
}: {
  open: boolean;
  toggleDialog: (b: boolean) => void;
  documentCardID: number | null;
  versionView: number | null;
  closeAllModals: boolean;
  setCloseAllModals: (b: boolean) => void;
}) => {
  const [formData, setFormData] = useState<any>({});
  const [updateCardData, setUpdateCardData] = useState<any>(null);
  const [card, setCard] = useState<any>(null);
  const [activeTabKey, setActiveTabKey] = useState("card");
  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const [idRemoveElem, setIdRemoveElem] = useState<any>(null);
  const currentUser: any = useAppSelector(selectCurrentUser);
  const [isFavoriteCard, setIsFavoriteCard] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [openCancelAddCard, setOpenCancelAddCard] = useState(false);
  const [showConfirmChangeStatus, setShowConfirmChangeStatus] = useState(false);
  const [approversCardDocumentData, setApproversCardDocumentData] = useState<any>({});
  const [removeObjData, setRemoveObjData] = useState<any>([]);
  const [hideCloseIcon, setHideCloseIcon] = useState(false);
  const [showEditApprovers, setShowEditApprovers] = useState(false);
  const [approvers, setApprovers] = useState<any>({});
  const [openReturnToWork, setOpenReturnToWork] = useState(false);
  const [customLoading, setCustomLoading] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [loadingArchive, setLoadingArchive] = useState(false);
  const [sendApproveBlock, setSendApproveBlock] = useState(false);
  const [versionsDocument, setVersionsDocument] = useState<any>([]);
  const [archiveConfirm, setArchiveConfirm] = useState(false);
  const [archiveEnd, setArchiveEnd] = useState(false);
  const [removeDocument, setRemoveDocument] = useState(false);
  const users: any = useAppSelector(selectUsers);
  const navigate = useNavigate();
  const repeatEmails: any = useAppSelector((state) =>
    selectItems(state, paramsListName)
  );
  const [numberVersionCurrentCard, setNumberVersionCurrentCard] =
    useState<any>(1);
  const [versionLoading, setVersionLoading] = useState(false);
  const [reportDocument, setReportDocument] = useState(false);
  const [approversDependencies, setApproversDependencies] = useState<any>([]);
  const [query, setQuery] = useSearchParams();
  const [videoFile, setVideoFile] = useState(false);
  const [favoriteDocument, setFavoriteDocument] = useState<any>([]);
  const [approversList, setApproversList] = useState<any>([]);
  const [documentFile, setDocumentFile] = useState<any>([]);
  const [viewDocMode, setViewDocMode] = useState(false);
  const [imagesDoc, setImagesDoc] = useState([]);
  const [viewAudit, setViewAudit] = useState<any>(null);
  const [viewOwd, setViewOwd] = useState<any>(null);
  const { status } = useStatusContext();
  const [auditLoading, setAuditLoading] = useState(false);
  const [owdLoading, setOwdLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (imagesDoc.length > 0) {
      setViewDocMode(true);
    }
  }, [imagesDoc]);

  //Определение версии документа
  useEffect(() => {
    if (!currentUser?.id || !documentCardID) {
      return;
    }

    const loadData = async () => {
      setVersionLoading(true);

      try {
        const result: any = await getItemsRequest({
          listName: myDocumentsListName,
          filters: { ID: documentCardID },
        });

        const tempCard =
          result?.items?.length > 0 ? result.items[0] : null;

        if (tempCard) {
          const versionsResult = await getItemsRequest({
            listName: versionsByDocumentListName,
            filters: { MainDocument: documentCardID },
          });

          const versions = versionsResult?.items || [];

          setVersionsDocument([...versions]);

          const tempVersionsIds = versions
            .map((version: any) => version.ID)
            .filter(Boolean);

          let tempHistoryCard: any[] = [];

          // Не отправляем запрос с пустым массивом ID
          if (tempVersionsIds.length > 0) {
            const versionHistoryResult = await getItemsRequest({
              listName: historyChangeFieldsDocumentListName,
              filters: {
                DocumentID: tempVersionsIds,
                Statuses: [docStatuses.edited, docStatuses.sendApproval],
                VersionDocument: true,
              },
            });

            tempHistoryCard = [...(versionHistoryResult?.items || [])];
          }

          if (tempCard.ID) {
            const cardHistoryResult = await getItemsRequest({
              listName: historyChangeFieldsDocumentListName,
              filters: {
                DocumentID: tempCard.ID,
                Statuses: [docStatuses.edited, docStatuses.sendApproval],
                VersionDocument: false,
              },
            });

            tempHistoryCard = [
              ...tempHistoryCard,
              ...(cardHistoryResult?.items || []),
            ];
          }

          const historyCard = _.orderBy(
            Array.from(
              new Map(
                tempHistoryCard
                  .filter((history: any) =>
                    containsAllIds(history.Statuses, [
                      docStatuses.edited,
                      docStatuses.sendApproval,
                    ])
                  )
                  .map((item: any) => [item.DocumentID, item])
              ).values()
            ),
            "ID",
            "asc"
          );

          if (versionView) {
            historyCard.forEach((history: any, idx: number) => {
              if (
                history.DocumentID === Number(versionView) &&
                history.VersionDocument
              ) {
                setNumberVersionCurrentCard(idx + 1);
              }
            });
          } else {
            historyCard.forEach((history: any, idx: number) => {
              if (history.DocumentID === Number(documentCardID)) {
                setNumberVersionCurrentCard(idx + 1);
              }
            });
          }
        }

        const approversResult = await getItemsRequest({
          listName: approversListName,
        });

        setApproversList([...(approversResult?.items || [])]);

        const cardID = versionView || documentCardID;

        // Здесь дополнительно проверяем CardID
        if (cardID) {
          const versionDocument = Boolean(versionView);

          const filesResult = await getItemsRequest({
            listName: documentByCardFilesLibName,
            filters: {
              CardID: cardID,
              ForHistory: false,
              VersionDocument: versionDocument,
            },
            sortOrder: {
              name: "Modified",
              desc: true,
            },
          });

          if (filesResult?.items?.length > 0) {
            setDocumentFile([...filesResult.items]);
          } else {
            const historyFilesResult = await getItemsRequest({
              listName: documentByCardFilesLibName,
              filters: {
                CardID: cardID,
                ForHistory: true,
                VersionDocument: versionDocument,
              },
              sortOrder: {
                name: "Modified",
                desc: true,
              },
            });

            setDocumentFile([...(historyFilesResult?.items || [])]);
          }
        }
      } finally {
        setVersionLoading(false);
      }
    };

    loadData();
  }, [documentCardID, activeTabKey, versionView, currentUser]);

  //Проверяем есть ли у текущего пользователя уведомления о ознакомлении и проведении OWD к текущему доку
  useEffect(() => {
    if (currentUser.id && card) {
      setAuditLoading(true);
      setOwdLoading(true);
      getItemsRequest({ listName: notificationsCardListName, filters: { Document: documentCardID, VersionDocument: null, NotificationType: notificationStatuses.familiarization, Employee: currentUser.id }, sortOrder: { name: 'ID', desc: true } }).then((result) => {
        let audit;
        if (result.items.length > 1) {
          audit = result.items[0];
          const ids = result.items.filter((item, idx) => idx !== 0).map((item) => {
            return {
              ID: item.ID
            }
          });
          if (ids.length > 0) {
            deleteItemRequest({ listName: notificationsCardListName, ID: 0, Ids: ids });
          }
        } else if (result.items.length === 1) {
          audit = result.items[0];
        }
        setViewAudit(audit);
        setAuditLoading(false);
        getItemsRequest({ listName: notificationsCardListName, filters: { Document: documentCardID, VersionDocument: null, NotificationType: notificationStatuses.OWD, Employee: currentUser.id, TestedEmployee: null } }).then((result) => {
          let owd = result.items.length > 0 && result.items[0] || null;
          setViewOwd(owd);
          setOwdLoading(false);
        });
      });

      if (card) {
        getItemsRequest({ listName: approversDependenciesListName, filters: { Collection: card.Collection.get_lookupId(), DocType: card.DocType.get_lookupId() } }).then(results => {
          setApproversDependencies([...results.items]);
        })
      }
    }
  }, [card, activeTabKey, currentUser, status]);

  const dialogToggleReportDocument = (b: boolean) => {
    setReportDocument(b);
  };

  const dialogToggleArchiveConfirm = (b: boolean) => {
    setArchiveConfirm(b);
  };

  const dialogToggleRemoveDocument = (b: boolean) => {
    setRemoveDocument(b);
  };

  const dialogToggleArchiveEnd = (b: boolean) => {
    setArchiveEnd(b);
  };

  const dialogToggleCancelAddCard = (b: boolean) => {
    setOpenCancelAddCard(b);
  };

  const dialogToggleApproveBlock = (b: boolean) => {
    setSendApproveBlock(b);
  };

  const dialogToggleReturnToWork = (b: boolean) => {
    setOpenReturnToWork(b);
  };

  const dialogToggleConfirmRemove = (b: boolean) => {
    setShowConfirmRemove(b);
  };

  const dialogToggleConfirmChangeStatus = (b: boolean) => {
    setShowConfirmChangeStatus(b);
  };

  const dialogToggleEditApprovers = (b: boolean) => {
    setShowEditApprovers(b);
  };

  // Очищаем только временные данные карточки. Secure Storage тоже использует localStorage в web.
  useEffect(() => {
    clearDocumentCardStorage();
  }, []);

  //Показываем крестик закрытия модалк при изменении вкладки
  useEffect(() => {
    setHideCloseIcon(false);
  }, [activeTabKey]);

  //Добавление уже удалённых элементов в отдельных объект, чтобы не ломалась форма
  useEffect(() => {
    if (idRemoveElem) {
      setRemoveObjData([...removeObjData, idRemoveElem]);
      setShowConfirmRemove(true);
    }
  }, [idRemoveElem]);

  //Отключаем все модалки и очищаем localStorage данные
  useEffect(() => {
    setOpenCancelAddCard(false);
    setShowConfirmRemove(false);
    setShowConfirmChangeStatus(false);
    setSendApproveBlock(false);
    setArchiveConfirm(false);
    setArchiveEnd(false);
    setRemoveDocument(false);
    setReportDocument(false);
    localStorage.setItem("noAddArchive", "");
  }, [closeAllModals]);

  //Очищаем список удалённых элементов, после закрытия модалки отправки формы
  useEffect(() => {
    if (!showConfirmRemove) {
      setIdRemoveElem(null);
    }
  }, [showConfirmRemove]);

  //Проверяем был ли добавлен док в избранное пользователем
  useEffect(() => {
    if (currentUser.id && documentCardID) {
      getItemsRequest({ listName: favoriteDocumentsListName, filters: { Document: documentCardID, Author: currentUser.id } }).then((results) => {
        setFavoriteDocument([...results.items]);
      });
    }
  }, [currentUser, documentCardID]);

  useEffect(() => {
    if (favoriteDocument && Object.keys(favoriteDocument).length > 0) {
      setIsFavoriteCard(true);
    } else {
      setIsFavoriteCard(false);
    }
  }, [favoriteDocument]);

  // Добавляем/удаляем док из избранного
  const toggleFavorite = () => {
    if (!isFavoriteCard) {
      addItemRequest({
        listName: favoriteDocumentsListName, body: {
          Title: `Add card in favorite for ${currentUser.displayName}`,
          Document: documentCardID,
        }
      }).then(() => {
        setIsFavoriteCard(true);
      });
    } else {
      deleteItemRequest({ listName: favoriteDocumentsListName, ID: favoriteDocument[0]['ID'] }).then(() => {
        setIsFavoriteCard(false);
      });
    }
  };

  //Если данные карточки сформированы и отправлены на следующий этап, открываем модалку отправки
  useEffect(() => {
    if (Object.keys(approversCardDocumentData).length > 0) {
      setShowConfirmChangeStatus(true);
    }
  }, [approversCardDocumentData]);

  useEffect(() => {
    if (updateCardData) {
      setShowEditApprovers(true);
    }
  }, [updateCardData]);

  //Возвращение карточки в работу и Разархивирование документа - START
  useEffect(() => {
    if (
      card &&
      card.Status.get_lookupId() === docStatuses.public &&
      versionView &&
      Object.keys(approvers).length > 0 &&
      localStorage.getItem("returnToWork")
    ) {
      localStorage.setItem("returnToWork", "");
      setShowEditApprovers(false);
      setCustomLoading(true);
      const updateCard = {
        Status: docStatuses.approval,
        ID: card.ID,
        AuthorEmail: currentUser.email.toLowerCase(),
      };
      let dataApproversCard: any = [],
        dataHistoryCard: any = [],
        historyFields: any = {},
        dataNotificationCard: any = [];
      dataApproversCard = [
        ...dataApproversCard,
        {
          Title: `Approver version card # ${card.ID}`,
          Approvers: [currentUser.email],
          Document: card.ID,
          VersionDocument: true,
          Group: docApprovers.Creater, // Список Approvers - Создатель
          Statuses: [docStatuses.reWork, docStatuses.sendApproval], //Список Statuses - Возвращен в работу, Отправлен на согласование
        },
      ];
      dataHistoryCard = [
        ...dataHistoryCard,
        {
          Title: `History version card # ${card.ID}`,
          Comment: "",
          VersionDocument: true,
          ChangeDate: new Date(),
          Approvers: [currentUser.email],
          DocumentID: card.ID,
          ApprovalGroup: docApprovers.Creater, // Список Approvers - Создатель
          Statuses: [docStatuses.reWork, docStatuses.sendApproval], //Список Statuses - Возвращен в работу, Отправлен на согласование
        },
      ];
      historyFields = {
        Title: `History version fields card # ${card.ID}`,
        DocumentID: card.ID,
        ChangeDate: new Date(),
        VersionDocument: true,
        Statuses: [docStatuses.reWork, docStatuses.sendApproval], //Список Statuses - Возвращен в работу, Отправлен на согласование
        Comment: "",
      };
      let dataArr: any = [];
      Object.keys(approvers).map(async (key: string, idx: number) => {
        const people: { avatar: string; label: string; value: string }[] =
          approvers[key];
        let sendPeople: string[] = [];
        people.map((user: any) => {
          if (user.value) {
            sendPeople = [...sendPeople, user.value.toLowerCase()];
          }
        });
        const groupID =
          approversList.filter((item: any) => item.Code === key).length > 0 &&
          approversList.filter((item: any) => item.Code === key)[0]["ID"];
        if (checkApprovers(groupID, approversDependencies)) {
          if (sendPeople.length > 0) {
            sendPeople.forEach((email: any) => {
              dataNotificationCard = [
                ...dataNotificationCard,
                {
                  Title: `Согласовать версию # ${card.ID}`,
                  ReviewDate: moment(new Date())
                    .add(
                      Number(
                        repeatEmails
                          .find(
                            (param: any) => param.Key === "documentsApproveDays"
                          )
                        ["Value"].trim()
                      ),
                      "days"
                    )
                    .toDate(),
                  AuthorComment: "",
                  VersionDocument: card.ID,
                  DocumentCode: `${card.Code}.${card.Index}`,
                  Document: card.MainDocument.get_lookupId(),
                  NotificationType: notificationStatuses.approval, // Согласовать
                  Employee: email.toLowerCase(),
                  EmployeeEmail: email.toLowerCase(),
                  AuthorEmail: currentUser.email.toLowerCase(),
                  Completed: new Date(),
                },
              ];
            });

            if (emailsSender) {
              let emailsHanleArr: any = [];
              const minutes = Number(
                repeatEmails
                  .find((param: any) => param.Key === "documentApprove")
                ["Value"].trim()
              );
              const dateSendEmailsArr = [
                moment(new Date()).clone().subtract(12, "hours").toDate(),
                moment(new Date()).clone().add(minutes, "m").toDate(),
              ];
              dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                sendPeople.forEach((email: any) => {
                  const emailBody = {
                    Body: `Здравствуйте ${users[email.toLowerCase()] &&
                      users[email.toLowerCase()]["displayName"]
                      },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${card.MainDocument.get_lookupId()
                      }&version=${card.ID}">${card.Title
                      }</a><br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                      }>${moment(new Date())
                        .add(
                          Number(
                            repeatEmails
                              .find(
                                (param: any) =>
                                  param.Key === "documentsApproveDays"
                              )
                            ["Value"].trim()
                          ),
                          "days"
                        )
                        .format("DD.MM.YYYY")}</span>`,
                    DateToBeSentAt: date,
                    Title: "Мои Документы | Согласование документа",
                    Subject: "Мои Документы | Согласование документа",
                    Recepients: email,
                    CheckDoc: String(card.MainDocument.get_lookupId()),
                    RepeatAt: (idxDate === 1 && minutes) || 0,
                  };
                  emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
                });
              });
              dataArr = [...dataArr, ...emailsHanleArr];
            }
          }
        }
        dataApproversCard = [
          ...dataApproversCard,
          {
            Title: `Approver version card # ${card.ID}`,
            Approvers: sendPeople,
            Document: card.ID,
            VersionDocument: true,
            Group: groupID,
            Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
            Queue: checkApprovers(groupID, approversDependencies), // В зависимости от коллекции руководитель или безопасность
          },
        ];
        dataHistoryCard = [
          ...dataHistoryCard,
          {
            Title: `History version card # ${card.ID}`,
            Comment: "",
            Approvers: sendPeople,
            ChangeDate: new Date(),
            VersionDocument: true,
            DocumentID: card.ID,
            ApprovalGroup: groupID,
            Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
          },
        ];
      });
      dataArr = [...dataArr, ...[
        addItemRequest({
          listName: approversCardDocumentListName,
          bodyArr: dataApproversCard,
          body: dataApproversCard[0],
          updateReducer: false,
        }),
        addItemRequest({
          listName: historyChangeFieldsDocumentListName,
          body: historyFields,
          updateReducer: false,
        }),
        addItemRequest({
          listName: historyByDocumentListName,
          bodyArr: dataHistoryCard,
          body: dataHistoryCard[0],
          updateReducer: false,
        }),
        updateItemRequest({
          listName:
            (versionView && versionsByDocumentListName) || myDocumentsListName,
          body: updateCard,
        })]
      ];
      if (dataNotificationCard.length > 0) {
        dataArr = [
          ...dataArr,
          addItemRequest({
            listName: notificationsListName,
            body: dataNotificationCard[0],
            bodyArr: dataNotificationCard,
            updateReducer: false,
          }),
        ];
      }
      Promise.all(dataArr).then((results) => {
        setCustomLoading(false);
        dispatch(getWorkDocumentsInfo({ listName: myWorksDocumentsListName }));
        navigate(`/dashboard/1`);
        navigate(0);
      });
      setApprovers({});
    }
    if (
      card &&
      card.Status.get_lookupId() === docStatuses.archive &&
      Object.keys(approvers).length > 0 &&
      localStorage.getItem("archiveEnd")
    ) {
      localStorage.setItem("archiveEnd", "");
      setShowEditApprovers(false);
      setCustomLoading(true);
      const updateCard = {
        Status: docStatuses.approval,
        ID: card.ID,
        AuthorEmail: currentUser.email.toLowerCase(),
      };
      let dataApproversCard: any = [],
        dataHistoryCard: any = [],
        historyFields: any = {},
        dataNotificationCard: any = [];
      dataApproversCard = [
        ...dataApproversCard,
        {
          Title: `Approver card # ${card.ID}`,
          Approvers: [currentUser.email],
          Document: card.ID,
          Group: docApprovers.Creater, // Список Approvers - Создатель
          Statuses: [docStatuses.notArchive, docStatuses.sendApproval], //Список Statuses - Разархивирование, Отправлен на согласование
        },
      ];
      dataHistoryCard = [
        ...dataHistoryCard,
        {
          Title: `History card # ${card.ID}`,
          Approvers: [currentUser.email],
          DocumentID: card.ID,
          ChangeDate: new Date(),
          ApprovalGroup: docApprovers.Creater, // Список Approvers - Создатель
          Statuses: [docStatuses.notArchive, docStatuses.sendApproval], //Список Statuses - Разархивирование, Отправлен на согласование
        },
      ];
      historyFields = {
        Title: `History fields card # ${card.ID}`,
        DocumentID: card.ID,
        ChangeDate: new Date(),
        Statuses: [docStatuses.notArchive, docStatuses.sendApproval], //Список Statuses - Разархивирование, Отправлен на согласование
      };
      let dataArr: any = [];
      Object.keys(approvers).map((key: string, idx: number) => {
        const people: { avatar: string; label: string; value: string }[] =
          approvers[key];
        let sendPeople: string[] = [];
        people.map((user) => {
          if (user.value) {
            sendPeople = [...sendPeople, user.value.toLowerCase()];
          }
        });
        const groupID =
          approversList.filter((item: any) => item.Code === key).length > 0 &&
          approversList.filter((item: any) => item.Code === key)[0]["ID"];
        if (checkApprovers(groupID, approversDependencies)) {
          if (sendPeople.length > 0) {
            sendPeople.forEach((email: any) => {
              dataNotificationCard = [
                ...dataNotificationCard,
                {
                  Title: `Согласовать # ${card.ID}`,
                  ReviewDate: moment(new Date())
                    .add(
                      Number(
                        repeatEmails
                          .find(
                            (param: any) => param.Key === "documentsApproveDays"
                          )
                        ["Value"].trim()
                      ),
                      "days"
                    )
                    .toDate(),
                  AuthorComment: "",
                  DocumentCode: `${card.Code}.${card.Index}`,
                  Document: card.ID,
                  NotificationType: notificationStatuses.approval, // Согласовать
                  Employee: email.toLowerCase(),
                  EmployeeEmail: email.toLowerCase(),
                  AuthorEmail: currentUser.email.toLowerCase(),
                  Completed: new Date(),
                },
              ];
            });
            if (emailsSender) {
              let emailsHanleArr: any = [];
              const minutes = Number(
                repeatEmails
                  .find((param: any) => param.Key === "documentApprove")
                ["Value"].trim()
              );
              const dateSendEmailsArr = [
                moment(new Date()).clone().subtract(12, "hours").toDate(),
                moment(new Date()).clone().add(minutes, "m").toDate(),
              ];
              dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                sendPeople.forEach((email: any) => {
                  const emailBody = {
                    Body: `Здравствуйте ${users[email.toLowerCase()] &&
                      users[email.toLowerCase()]["displayName"]
                      },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${card.ID
                      }">${card.Title}</a><br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                      }>${moment(new Date())
                        .add(
                          Number(
                            repeatEmails
                              .find(
                                (param: any) =>
                                  param.Key === "documentsApproveDays"
                              )
                            ["Value"].trim()
                          ),
                          "days"
                        )
                        .format("DD.MM.YYYY")}</span>`,
                    DateToBeSentAt: date,
                    Title: "Мои Документы | Согласование документа",
                    Subject: "Мои Документы | Согласование документа",
                    Recepients: email,
                    CheckDoc: String(card.ID),
                    RepeatAt: (idxDate === 1 && minutes) || 0,
                  };
                  emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
                });
              });
              dataArr = [...dataArr, ...emailsHanleArr];
            }
          }
        }
        dataApproversCard = [
          ...dataApproversCard,
          {
            Title: `Approver card # ${card.ID}`,
            Approvers: sendPeople,
            Document: card.ID,
            Group: groupID,
            Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
            Queue: checkApprovers(groupID, approversDependencies),
          },
        ];
        dataHistoryCard = [
          ...dataHistoryCard,
          {
            Title: `History card # ${card.ID}`,
            Approvers: sendPeople,
            DocumentID: card.ID,
            ChangeDate: new Date(),
            ApprovalGroup: groupID,
            Statuses: [docStatuses.waitApproval], //Список Statuses - Ожидает согласования
          },
        ];
      });
      dataArr = [...dataArr, ...[
        addItemRequest({
          listName: approversCardDocumentListName,
          bodyArr: dataApproversCard,
          body: dataApproversCard[0],
          updateReducer: false,
        }),
        addItemRequest({
          listName: historyChangeFieldsDocumentListName,
          body: historyFields,
          updateReducer: false,
        }),
        addItemRequest({
          listName: historyByDocumentListName,
          bodyArr: dataHistoryCard,
          body: dataHistoryCard[0],
          updateReducer: false,
        }),
        updateItemRequest({
          listName:
            (versionView && versionsByDocumentListName) || myDocumentsListName,
          body: updateCard,
        })]
      ];
      if (dataNotificationCard.length > 0) {
        dataArr = [
          ...dataArr,
          addItemRequest({
            listName: notificationsListName,
            body: dataNotificationCard[0],
            bodyArr: dataNotificationCard,
            updateReducer: false,
          }),
        ];
      }
      Promise.all(dataArr).then((results) => {
        setCustomLoading(false);
        dispatch(getWorkDocumentsInfo({ listName: myWorksDocumentsListName }));
        navigate(`/dashboard/1`);
        navigate(0);
      });
      setApprovers({});
    }
  }, [approvers]);

  const checkReturnToWork = () => {
    localStorage.setItem("returnToWork", "true");
  };
  const archiveEndHandle = () => {
    localStorage.setItem("archiveEnd", "true");
    setArchiveEnd(true);
  };
  //Возвращение карточки в работу и Разархивирование документа - END

  //Удаление карточки - START
  useEffect(() => {
    //Удаление из отмены или доработки
    if (
      card &&
      (card.Status.get_lookupId() === docStatuses.revision ||
        card.Status.get_lookupId() === docStatuses.cancel ||
        card.Status.get_lookupId() === docStatuses.archive) &&
      localStorage.getItem("removeDocument") &&
      !removeDocument
    ) {
      localStorage.setItem("removeDocument", "");
      setCustomLoading(true);
      if (card.MainDocument) {
        let removeData: any = [];
        let documentVersionsRequests: any = [];
        let approversVersionsRequests: any = [];
        let equipmentsVersionsRequests: any = [];
        let historyVersionsRequests: any = [];
        let historyFieldsVersionsRequests: any = [];
        let lastHistoryFieldsMainRequests: any = [];
        let notificationRequests: any = [];
        documentVersionsRequests = [
          ...documentVersionsRequests,
          getItemsRequest({
            listName: documentByCardFilesLibName,
            filters: { CardID: card.ID, VersionDocument: true },
          }),
        ];
        approversVersionsRequests = [
          ...approversVersionsRequests,
          getItemsRequest({
            listName: approversCardDocumentListName,
            filters: { Document: card.ID, VersionDocument: true },
          }),
        ];
        equipmentsVersionsRequests = [
          ...equipmentsVersionsRequests,
          getItemsRequest({
            listName: equipmentsByDocumentListName,
            filters: { Document: card.ID, VersionDocument: true },
          }),
        ];
        historyVersionsRequests = [
          ...historyVersionsRequests,
          getItemsRequest({
            listName: historyByDocumentListName,
            filters: { DocumentID: card.ID, VersionDocument: true },
          }),
        ];
        historyFieldsVersionsRequests = [
          ...historyFieldsVersionsRequests,
          getItemsRequest({
            listName: historyChangeFieldsDocumentListName,
            filters: { DocumentID: card.ID, VersionDocument: true },
          }),
        ];
        lastHistoryFieldsMainRequests = [
          ...lastHistoryFieldsMainRequests,
          getItemsRequest({
            listName: historyChangeFieldsDocumentListName,
            filters: {
              DocumentID: card.MainDocument.get_lookupId(),
              VersionDocument: false,
              Statuses: [docStatuses.edited, docStatuses.sendApproval],
            },
            sortOrder: { name: "ID", desc: true },
            rowLimit: 1,
          }),
        ];
        notificationRequests = [
          ...notificationRequests,
          getItemsRequest({
            listName: notificationsListName,
            filters: { VersionDocument: card.ID },
          }),
        ];
        removeData = [
          ...removeData,
          deleteItemRequest({
            listName: versionsByDocumentListName,
            ID: card.ID,
          }),
        ];
        Promise.all(documentVersionsRequests).then((values: any) => {
          if (values.length > 0) {
            values.forEach((value: any) => {
              if (value.items.length > 0) {
                value.items.forEach((document: any) => {
                  removeData = [
                    ...removeData,
                    deleteItemRequest({
                      listName: documentByCardFilesLibName,
                      ID: document.ID,
                      fileField: "File",
                    }),
                  ];
                });
              }
            });
          }
          Promise.all(approversVersionsRequests).then((values: any) => {
            if (values.length > 0) {
              values.forEach((value: any) => {
                if (value.items.length > 0) {
                  value.items.forEach((approver: any) => {
                    removeData = [
                      ...removeData,
                      deleteItemRequest({
                        listName: approversCardDocumentListName,
                        ID: approver.ID,
                      }),
                    ];
                  });
                }
              });
            }
            Promise.all(equipmentsVersionsRequests).then((values: any) => {
              if (values.length > 0) {
                values.forEach((value: any) => {
                  if (value.items.length > 0) {
                    value.items.forEach((equipment: any) => {
                      removeData = [
                        ...removeData,
                        deleteItemRequest({
                          listName: equipmentsByDocumentListName,
                          ID: equipment.ID,
                        }),
                      ];
                    });
                  }
                });
              }
              Promise.all(historyVersionsRequests).then((values: any) => {
                if (values.length > 0) {
                  values.forEach((value: any) => {
                    if (value.items.length > 0) {
                      value.items.forEach((history: any) => {
                        removeData = [
                          ...removeData,
                          deleteItemRequest({
                            listName: historyByDocumentListName,
                            ID: history.ID,
                          }),
                        ];
                      });
                    }
                  });
                }
                Promise.all(historyFieldsVersionsRequests).then(
                  (values: any) => {
                    if (values.length > 0) {
                      values.forEach((value: any) => {
                        if (value.items.length > 0) {
                          value.items.forEach((historyField: any) => {
                            removeData = [
                              ...removeData,
                              deleteItemRequest({
                                listName: historyChangeFieldsDocumentListName,
                                ID: historyField.ID,
                              }),
                            ];
                          });
                        }
                      });
                    }
                    Promise.all(lastHistoryFieldsMainRequests).then(
                      (values: any) => {
                        if (values.length > 0) {
                          values.forEach((value: any) => {
                            if (value.items.length > 0) {
                              value.items.forEach((historyField: any) => {
                                removeData = [
                                  ...removeData,
                                  deleteItemRequest({
                                    listName:
                                      historyChangeFieldsDocumentListName,
                                    ID: historyField.ID,
                                  }),
                                ];
                              });
                            }
                          });
                        }
                        Promise.all(notificationRequests).then(
                          (values: any) => {
                            if (values.length > 0) {
                              values.forEach((value: any) => {
                                if (value.items.length > 0) {
                                  value.items.forEach((notification: any) => {
                                    removeData = [
                                      ...removeData,
                                      deleteItemRequest({
                                        listName: notificationsListName,
                                        ID: notification.ID,
                                      }),
                                    ];
                                  });
                                }
                              });
                              Promise.all(removeData).then((results: any) => {
                                dispatch(
                                  getWorkDocumentsInfo({
                                    listName: myWorksDocumentsListName,
                                  })
                                );
                                setCustomLoading(false);
                                setCloseAllModals(!closeAllModals);
                                navigate(`/dashboard/1`);
                                navigate(0);
                              });
                            }
                          }
                        );
                      }
                    );
                  }
                );
              });
            });
          });
        });
      } else {
        let removeData: any = [];
        let documentRequests: any = [];
        let approversRequests: any = [];
        let equipmentsRequests: any = [];
        let historyRequests: any = [];
        let historyFieldsRequests: any = [];
        let notificationRequests: any = [];
        let favoritesRequests: any = [];
        let copiesCardDocument: any = [];
        let listsApprovers: any = [];
        let emailQueue: any = [];
        let activityAnalysis: any = [];
        activityAnalysis = [
          ...activityAnalysis,
          getItemsRequest({
            listName: activityAnalysisListName,
            filters: { Document: card.ID },
          }),
        ];
        favoritesRequests = [
          ...favoritesRequests,
          getItemsRequest({
            listName: favoriteDocumentsListName,
            filters: { Document: card.ID },
          }),
        ];
        documentRequests = [
          ...documentRequests,
          getItemsRequest({
            listName: documentByCardFilesLibName,
            filters: { CardID: card.ID, VersionDocument: false },
          }),
        ];
        approversRequests = [
          ...approversRequests,
          getItemsRequest({
            listName: approversCardDocumentListName,
            filters: { Document: card.ID, VersionDocument: false },
          }),
        ];
        equipmentsRequests = [
          ...equipmentsRequests,
          getItemsRequest({
            listName: equipmentsByDocumentListName,
            filters: { Document: card.ID, VersionDocument: false },
          }),
        ];
        historyRequests = [
          ...historyRequests,
          getItemsRequest({
            listName: historyByDocumentListName,
            filters: { DocumentID: card.ID, VersionDocument: false },
          }),
        ];
        historyFieldsRequests = [
          ...historyFieldsRequests,
          getItemsRequest({
            listName: historyChangeFieldsDocumentListName,
            filters: { DocumentID: card.ID, VersionDocument: false },
          }),
        ];
        notificationRequests = [
          ...notificationRequests,
          getItemsRequest({
            listName: notificationsListName,
            filters: { Document: card.ID },
          }),
        ];
        copiesCardDocument = [
          ...copiesCardDocument,
          getItemsRequest({
            listName: copiesCardDocumentListName,
            filters: { DocumentID: card.ID },
          }),
        ];
        listsApprovers = [
          ...listsApprovers,
          getItemsRequest({
            listName: listsApproversListName,
            filters: { DocumentID: card.ID },
          }),
        ];
        emailQueue = [
          ...emailQueue,
          getItemsRequest({
            listName: emailQueueListName,
            filters: { CheckDoc: String(card.ID) },
          }),
        ];

        Promise.all(activityAnalysis).then((values: any) => {
          if (values.length > 0) {
            values.forEach((value: any) => {
              if (value.items.length > 0) {
                value.items.forEach((aciveItem: any) => {
                  removeData = [
                    ...removeData,
                    deleteItemRequest({
                      listName: activityAnalysisListName,
                      ID: aciveItem.ID,
                    }),
                  ];
                });
              }
            });
          }
          Promise.all(documentRequests).then((values: any) => {
            if (values.length > 0) {
              values.forEach((value: any) => {
                if (value.items.length > 0) {
                  value.items.forEach((document: any) => {
                    removeData = [
                      ...removeData,
                      deleteItemRequest({
                        listName: documentByCardFilesLibName,
                        ID: document.ID,
                        fileField: "File",
                      }),
                    ];
                  });
                }
              });
            }
            Promise.all(approversRequests).then((values: any) => {
              if (values.length > 0) {
                values.forEach((value: any) => {
                  if (value.items.length > 0) {
                    value.items.forEach((approver: any) => {
                      removeData = [
                        ...removeData,
                        deleteItemRequest({
                          listName: approversCardDocumentListName,
                          ID: approver.ID,
                        }),
                      ];
                    });
                  }
                });
              }
              Promise.all(equipmentsRequests).then((values: any) => {
                if (values.length > 0) {
                  values.forEach((value: any) => {
                    if (value.items.length > 0) {
                      value.items.forEach((equipment: any) => {
                        removeData = [
                          ...removeData,
                          deleteItemRequest({
                            listName: equipmentsByDocumentListName,
                            ID: equipment.ID,
                          }),
                        ];
                      });
                    }
                  });
                }
                Promise.all(historyRequests).then((values: any) => {
                  if (values.length > 0) {
                    values.forEach((value: any) => {
                      if (value.items.length > 0) {
                        value.items.forEach((history: any) => {
                          removeData = [
                            ...removeData,
                            deleteItemRequest({
                              listName: historyByDocumentListName,
                              ID: history.ID,
                            }),
                          ];
                        });
                      }
                    });
                  }
                  Promise.all(historyFieldsRequests).then((values: any) => {
                    if (values.length > 0) {
                      values.forEach((value: any) => {
                        if (value.items.length > 0) {
                          value.items.forEach((historyField: any) => {
                            removeData = [
                              ...removeData,
                              deleteItemRequest({
                                listName: historyChangeFieldsDocumentListName,
                                ID: historyField.ID,
                              }),
                            ];
                          });
                        }
                      });
                    }
                    Promise.all(notificationRequests).then((values: any) => {
                      if (values.length > 0) {
                        values.forEach((value: any) => {
                          if (value.items.length > 0) {
                            value.items.forEach((notification: any) => {
                              removeData = [
                                ...removeData,
                                deleteItemRequest({
                                  listName: notificationsListName,
                                  ID: notification.ID,
                                }),
                              ];
                            });
                          }
                        });
                      }
                      Promise.all(favoritesRequests).then((values: any) => {
                        if (values.length > 0) {
                          values.forEach((value: any) => {
                            if (value.items.length > 0) {
                              value.items.forEach((favorite: any) => {
                                removeData = [
                                  ...removeData,
                                  deleteItemRequest({
                                    listName: favoriteDocumentsListName,
                                    ID: favorite.ID,
                                  }),
                                ];
                              });
                            }
                          });
                        }
                        Promise.all(copiesCardDocument).then((values: any) => {
                          if (values.length > 0) {
                            values.forEach((value: any) => {
                              if (value.items.length > 0) {
                                value.items.forEach((copy: any) => {
                                  removeData = [
                                    ...removeData,
                                    deleteItemRequest({
                                      listName: copiesCardDocumentListName,
                                      ID: copy.ID,
                                    }),
                                  ];
                                });
                              }
                            });
                          }
                          Promise.all(listsApprovers).then((values: any) => {
                            if (values.length > 0) {
                              values.forEach((value: any) => {
                                if (value.items.length > 0) {
                                  value.items.forEach((list: any) => {
                                    removeData = [
                                      ...removeData,
                                      deleteItemRequest({
                                        listName: listsApproversListName,
                                        ID: list.ID,
                                      }),
                                    ];
                                  });
                                }
                              });
                            }
                            Promise.all(emailQueue).then((values: any) => {
                              if (values.length > 0) {
                                values.forEach((value: any) => {
                                  if (value.items.length > 0) {
                                    value.items.forEach((email: any) => {
                                      removeData = [
                                        ...removeData,
                                        deleteItemRequest({
                                          listName: emailQueueListName,
                                          ID: email.ID,
                                        }),
                                      ];
                                    });
                                  }
                                });
                              }
                              //Получаем версии и всю инфу для их удаления
                              new Promise((resolve, reject) => {
                                getItemsRequest({
                                  listName: versionsByDocumentListName,
                                  filters: { MainDocument: card.ID },
                                }).then((results: any) => {
                                  const versions = results.items;
                                  let versionsIds: any = [];
                                  if (versions.length > 0) {
                                    versions.forEach((version: any) => {
                                      versionsIds = [
                                        ...versionsIds,
                                        version.ID,
                                      ];
                                    });
                                    if (versionsIds.length > 0) {
                                      let documentVersionsRequests: any = [];
                                      let approversVersionsRequests: any = [];
                                      let equipmentsVersionsRequests: any = [];
                                      let historyVersionsRequests: any = [];
                                      let historyFieldsVersionsRequests: any =
                                        [];

                                      versionsIds.forEach((versionID: any) => {
                                        documentVersionsRequests = [
                                          ...documentVersionsRequests,
                                          getItemsRequest({
                                            listName:
                                              documentByCardFilesLibName,
                                            filters: {
                                              CardID: versionID,
                                              VersionDocument: true,
                                            },
                                          }),
                                        ];
                                        approversVersionsRequests = [
                                          ...approversVersionsRequests,
                                          getItemsRequest({
                                            listName:
                                              approversCardDocumentListName,
                                            filters: {
                                              Document: versionID,
                                              VersionDocument: true,
                                            },
                                          }),
                                        ];
                                        equipmentsVersionsRequests = [
                                          ...equipmentsVersionsRequests,
                                          getItemsRequest({
                                            listName:
                                              equipmentsByDocumentListName,
                                            filters: {
                                              Document: versionID,
                                              VersionDocument: true,
                                            },
                                          }),
                                        ];
                                        historyVersionsRequests = [
                                          ...historyVersionsRequests,
                                          getItemsRequest({
                                            listName: historyByDocumentListName,
                                            filters: {
                                              DocumentID: versionID,
                                              VersionDocument: true,
                                            },
                                          }),
                                        ];
                                        historyFieldsVersionsRequests = [
                                          ...historyFieldsVersionsRequests,
                                          getItemsRequest({
                                            listName:
                                              historyChangeFieldsDocumentListName,
                                            filters: {
                                              DocumentID: versionID,
                                              VersionDocument: true,
                                            },
                                          }),
                                        ];
                                        removeData = [
                                          ...removeData,
                                          deleteItemRequest({
                                            listName:
                                              versionsByDocumentListName,
                                            ID: versionID,
                                          }),
                                        ];
                                      });
                                      Promise.all(
                                        documentVersionsRequests
                                      ).then((values: any) => {
                                        if (values.length > 0) {
                                          values.forEach((value: any) => {
                                            if (value.items.length > 0) {
                                              value.items.forEach(
                                                (document: any) => {
                                                  removeData = [
                                                    ...removeData,
                                                    deleteItemRequest({
                                                      listName:
                                                        documentByCardFilesLibName,
                                                      ID: document.ID,
                                                      fileField: "File",
                                                    }),
                                                  ];
                                                }
                                              );
                                            }
                                          });
                                        }
                                        Promise.all(
                                          approversVersionsRequests
                                        ).then((values: any) => {
                                          if (values.length > 0) {
                                            values.forEach((value: any) => {
                                              if (value.items.length > 0) {
                                                value.items.forEach(
                                                  (approver: any) => {
                                                    removeData = [
                                                      ...removeData,
                                                      deleteItemRequest({
                                                        listName:
                                                          approversCardDocumentListName,
                                                        ID: approver.ID,
                                                      }),
                                                    ];
                                                  }
                                                );
                                              }
                                            });
                                          }
                                          Promise.all(
                                            equipmentsVersionsRequests
                                          ).then((values: any) => {
                                            if (values.length > 0) {
                                              values.forEach((value: any) => {
                                                if (value.items.length > 0) {
                                                  value.items.forEach(
                                                    (equipment: any) => {
                                                      removeData = [
                                                        ...removeData,
                                                        deleteItemRequest({
                                                          listName:
                                                            equipmentsByDocumentListName,
                                                          ID: equipment.ID,
                                                        }),
                                                      ];
                                                    }
                                                  );
                                                }
                                              });
                                            }
                                            Promise.all(
                                              historyVersionsRequests
                                            ).then((values: any) => {
                                              if (values.length > 0) {
                                                values.forEach((value: any) => {
                                                  if (value.items.length > 0) {
                                                    value.items.forEach(
                                                      (history: any) => {
                                                        removeData = [
                                                          ...removeData,
                                                          deleteItemRequest({
                                                            listName:
                                                              historyByDocumentListName,
                                                            ID: history.ID,
                                                          }),
                                                        ];
                                                      }
                                                    );
                                                  }
                                                });
                                              }
                                              Promise.all(
                                                historyFieldsVersionsRequests
                                              ).then((values: any) => {
                                                if (values.length > 0) {
                                                  values.forEach(
                                                    (value: any) => {
                                                      if (
                                                        value.items.length > 0
                                                      ) {
                                                        value.items.forEach(
                                                          (
                                                            historyField: any
                                                          ) => {
                                                            removeData = [
                                                              ...removeData,
                                                              deleteItemRequest(
                                                                {
                                                                  listName:
                                                                    historyChangeFieldsDocumentListName,
                                                                  ID: historyField.ID,
                                                                }
                                                              ),
                                                            ];
                                                          }
                                                        );
                                                      }
                                                    }
                                                  );
                                                }
                                                Promise.all(removeData).then(
                                                  (results: any) => {
                                                    deleteItemRequest({
                                                      listName:
                                                        myDocumentsListName,
                                                      ID: card.ID,
                                                    }).then((result: any) => {
                                                      setCustomLoading(false);
                                                      navigate(`/dashboard/1`);
                                                      navigate(0);
                                                    });
                                                  }
                                                );
                                              });
                                            });
                                          });
                                        });
                                      });
                                    }
                                  } else {
                                    Promise.all(removeData).then(
                                      (results: any) => {
                                        deleteItemRequest({
                                          listName: myDocumentsListName,
                                          ID: card.ID,
                                        }).then((result: any) => {
                                          dispatch(
                                            getWorkDocumentsInfo({
                                              listName:
                                                myWorksDocumentsListName,
                                            })
                                          );
                                          setCustomLoading(false);
                                          setCloseAllModals(!closeAllModals);
                                          navigate(`/dashboard/1`);
                                          navigate(0);
                                        });
                                      }
                                    );
                                  }
                                });
                              });
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      }
    }
  }, [removeDocument]);
  //Удаление карточки - END

  //Печать карточки - START
  const printHandle = () => {
    setLoadingPrint(true);
    getItemsRequest({ listName: historyChangeFieldsDocumentListName, filters: { DocumentID: documentCardID, VersionDocument: false }, sortOrder: { name: "ID", asc: true } }).then((results) => {
      const historyCard = [...results.items];
      getItemsRequest({ listName: historyByDocumentListName, filters: { DocumentID: documentCardID, VersionDocument: false }, sortOrder: { name: "ID", desc: true } }).then((results) => {
        const historyApprovers = getLatestUniqueGroups([...results.items]);
        // 1. Сортируем даты отдельно
        const sortedDates = [...historyApprovers]
          .map((item: any) => item.Created)
          .sort(
            (a: string, b: string) =>
              new Date(a).getTime() - new Date(b).getTime()
          );

        // 2. Сортируем элементы по order
        let tempHistoryCardOrder = historyApprovers
          .map((item: any) => {
            const group = approversDependencies.find(
              (group: any) =>
                group.Group?.get_lookupId?.() ===
                item.ApprovalGroup?.get_lookupId?.()
            );

            return {
              ...item,
              order: group?.Order0 ?? 0,
            };
          })
          .sort((a: any, b: any) => a.order - b.order)
          .map((item: any, index: number) => ({
            ...item,
            // 3. Подставляем даты по порядку
            Created: sortedDates[index],
          }));
        getItemsRequest({ listName: equipmentsByDocumentListName, filters: { Document: documentCardID, VersionDocument: false } }).then((results) => {
          const equipmentsByDocument = [...results.items];
          const file = documentFile[0];
          const extension = file.FileLeafRef.substring(
            file.FileLeafRef.lastIndexOf(".")
          ).toLowerCase();
          let approved_print: any = [];
          tempHistoryCardOrder.filter((history: any) =>
            history.Statuses.some(
              (status: any) =>
                status.get_lookupId() === docStatuses.approved ||
                status.get_lookupId() === docStatuses.public
            )
          )
            .forEach((history: any) => {
              approved_print = [
                ...approved_print,
                {
                  Name: users[history.Approved.get_email().toLowerCase()]?.[
                    "displayName"
                  ],
                  Position: users[history.Approved.get_email().toLowerCase()]?.["jobTitleStr"],
                  Date: moment(history.Created).format("DD.MM.YYYY"),
                },
              ];
            });
          let approvers_print: any = [];
          tempHistoryCardOrder.filter((history: any) =>
            history.Statuses.some(
              (status: any) => status.get_lookupId() === docStatuses.agreed
            )
          )
            .forEach((history: any) => {
              approvers_print = [
                ...approvers_print,
                {
                  Name: users[history.Approved.get_email().toLowerCase()]?.[
                    "displayName"
                  ],
                  Position: users[history.Approved.get_email().toLowerCase()]?.["jobTitleStr"],
                  Date: moment(history.Created).format("DD.MM.YYYY"),
                },
              ];
            });
          let equipments_print: any = [];
          equipmentsByDocument.forEach((equipment: any) => {
            equipments_print = [
              ...equipments_print,
              {
                Line: (equipment.Line && equipment.Line.get_lookupValue()) || "",
                SAP:
                  (equipment.Equipment &&
                    equipment.Equipment.Metadata &&
                    equipment.Equipment.Metadata.SAP) ||
                  "",
                Name:
                  (equipment.Equipment &&
                    equipment.Equipment.Metadata &&
                    equipment.Equipment.Metadata.Title) ||
                  "",
              },
            ];
          });
          const sendData = {
            id: file.ID,
            meta: {
              Code: `${card.Code}.${card.Index}`,
              Version: `Версия ${numberVersionCurrentCard}`,
              ApprovalDate: `Дата утверждения: ${approved_print.length > 0 && approved_print[0]["Date"]
                }`,
              Title: `${card.Title}`,
              DocType: `${card.DocType.get_lookupValue()}`,
              Collection: `${card.Collection.get_lookupValue()}`,
              Department: `${card.Department.get_lookupValue()}`,
              Sector: `${card.Sector.get_lookupValue()}`,
              Process: `${card.Process.get_lookupValue()}`,
              Author: {
                Position: users[card.AuthorEmail.toLowerCase()]?.["jobTitleStr"],
                Name: users[card.AuthorEmail.toLowerCase()]?.["displayName"],
                Date: moment(historyCard[0].Created).format("DD.MM.YYYY"),
              },
              Equipments: equipments_print,
              Approvers: approvers_print,
              Approved: approved_print,
              DateForRevision: moment(card.DateForRevision).format("DD.MM.YYYY"),
              PrintUser: { Name: currentUser.displayName },
              PrintDate: moment().format("DD.MM.YYYY"),
            },
          };

          if (extension === ".xlsx" || extension === ".docx") {
            axios({
              method: "post",
              url: `${siteUrl}/api/md-documents-files/title`,
              data: sendData,
              responseType: "blob",
              headers: {
                Accept: "application/json;odata=nometadata",
              },
            }).then((data) => {
              downLoadPrintFile(data.data, file.FileLeafRef);
              setLoadingPrint(false);
            });
          } else if (extension === ".txt" || extension === ".pdf") {
            printFileHandle(`${siteUrl + encodeURI(file.FileRef)}`);
            setLoadingPrint(false);
          } else {
            fetch(file.FileRef)
              .then((response) => response.blob())
              .then((blob) => {
                const printFile = new File([blob], file.FileLeafRef, {
                  type: blob.type,
                  lastModified: moment().unix(),
                });
                let reader = new FileReader();
                reader.readAsDataURL(printFile);
                reader.onload = function () {
                  const src = reader.result;
                  const linkDownLoad: HTMLAnchorElement =
                    document.createElement("a");
                  linkDownLoad.setAttribute("download", printFile.name);
                  // @ts-ignore
                  linkDownLoad.setAttribute("href", src);
                  linkDownLoad.style.display = "none";
                  document.body.appendChild(linkDownLoad);
                  linkDownLoad.click();
                  document.body.removeChild(linkDownLoad);
                  setLoadingPrint(false);
                  addAnalysis(
                    currentUser,
                    documentCardID,
                    `${card.Code}.${card.Index}`,
                    "isActive",
                    "Print"
                  );
                };
              });
          }
        });
      });
    });
  };
  const printFileHandle = (src: string) => {
    addAnalysis(
      currentUser,
      documentCardID,
      `${card.Code}.${card.Index}`,
      "isActive",
      "Print"
    );
    const hideFrame = document.createElement("iframe");
    hideFrame.style.display = "none"; // hide iframe
    hideFrame.src = src;
    document.body.appendChild(hideFrame);
    // @ts-ignore
    hideFrame.onload = setPrint(hideFrame);
  };
  const setPrint = (iframe: any) => {
    const closePrint = () => {
      document.body.removeChild(iframe);
    };
    iframe.contentWindow.onbeforeunload = closePrint;
    iframe.contentWindow.onafterprint = closePrint;
    iframe.contentWindow.print();
  };
  const downLoadPrintFile = (blob: any, fileName: string) => {
    addAnalysis(
      currentUser,
      documentCardID,
      `${card.Code}.${card.Index}`,
      "isActive",
      "Print"
    );
    const printFile = new File([blob], fileName, {
      type: blob.type,
      lastModified: moment().unix(),
    });
    let reader = new FileReader();
    reader.readAsDataURL(printFile);
    reader.onload = function () {
      const src = reader.result;
      const linkDownLoad: HTMLAnchorElement = document.createElement("a");
      linkDownLoad.setAttribute("download", printFile.name);
      // @ts-ignore
      linkDownLoad.setAttribute("href", src);
      linkDownLoad.style.display = "none";
      document.body.appendChild(linkDownLoad);
      linkDownLoad.click();
      document.body.removeChild(linkDownLoad);
    };
  };
  //Печать карточки - END

  return (
    <DialogComponent
      open={open}
      toggleDialog={toggleDialog}
      hideCloseIcon={hideCloseIcon}
    >
      <div className="step_1 md:min-w-[975px]">
        <div className="flex items-start justify-between">
          <div
            className="max-w-[70%] text-7.5 leading-[38px] font-bold text-black mb-8 break-words mr-5"
            dangerouslySetInnerHTML={{
              __html:
                (card && card.Title.replaceAll(" ", "&nbsp;")) ||
                "",
            }}
          />
          <span className="flex gap-x-2.5">
            {card && card.Status.get_lookupId() !== docStatuses.public && (
              <>
                {(versionView && card.Status.get_lookupId() === docStatuses.review && (
                  <></>
                )) || (
                    <TGTag
                      color={
                        ((card.Status.get_lookupId() === docStatuses.revision ||
                          card.Status.get_lookupId() === docStatuses.cancel) &&
                          "red") ||
                        "gray"
                      }
                    >
                      {card.Status.get_lookupValue()}
                    </TGTag>
                  )}
              </>
            )}
            {card &&
              versionView &&
              (card.Status.get_lookupId() === docStatuses.public ||
                card.Status.get_lookupId() === docStatuses.review ||
                card.Status.get_lookupId() === docStatuses.archive) &&
              !versionLoading &&
              numberVersionCurrentCard && (
                <TGTag color={"gray"}>Версия {numberVersionCurrentCard}</TGTag>
              )}
            {/* Если статус опубликован или на пересмотр */}
            {activeTabKey === "card" &&
              card &&
              !versionView &&
              (card.Status.get_lookupId() === docStatuses.public ||
                card.Status.get_lookupId() === docStatuses.review) && (
                <>
                  {!hideCloseIcon && (
                    <>
                      {card && location.pathname.indexOf('/1/notification') === -1 && (
                        <>
                          {auditLoading &&
                            <FlexCol className="flex w-6 h-6">
                              <Loading />
                            </FlexCol>
                            ||
                            <TooltipItem
                              position="top-left"
                              tooltipsText={viewAudit && viewAudit.Read && "Вы уже ознакомлены с этим документом" || "Ознакомиться с документом"}
                            >
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!viewAudit) {
                                    setAuditLoading(true);
                                    const days = Number(
                                      repeatEmails
                                        .find((param: any) => param.Key === "auditDateDefault")
                                      ["Value"].trim(),
                                    );
                                    addItemRequest({
                                      listName: notificationIdsListName,
                                      body: { Title: "Ознакомление" },
                                      updateReducer: false,
                                    }).then((notificationID) => {
                                      addItemRequest({
                                        listName: notificationsCardListName, body: {
                                          Title: "Уведомление " + notificationID,
                                          NotificationID: notificationID,
                                          Employee: currentUser.email,
                                          EmployeeEmail: currentUser.email,
                                          Document: card.ID,
                                          DocumentCode: `${card.Code}.${card.Index}`,
                                          ReviewDate: moment().add(days, 'days').toDate(),
                                          NotificationType: notificationStatuses.familiarization,
                                          AuthorEmail: currentUser.email,
                                        }
                                      }).then((resultId: any) => {
                                        const newSearchParams = new URLSearchParams(query);
                                        newSearchParams.set("notificationCard", resultId.toString());
                                        setQuery(newSearchParams);
                                        setAuditLoading(false);
                                        navigate(0);
                                      });
                                    });
                                  }
                                  if (viewAudit && !viewAudit.Read) {
                                    const newSearchParams = new URLSearchParams(query);
                                    newSearchParams.set("notificationCard", viewAudit.ID.toString());
                                    setQuery(newSearchParams);
                                  }
                                }}
                                className="flex w-6 h-6"
                              >
                                {viewAudit && viewAudit.Read && <AuditSuccessIcon /> || <AuditNotificationIcon />}
                              </a>
                            </TooltipItem>
                          }
                          {owdLoading &&
                            <FlexCol className="flex w-6 h-6">
                              <Loading />
                            </FlexCol>
                            ||
                            <TooltipItem
                              position="top-left"
                              tooltipsText={"Провести OWD"}
                            >
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!viewOwd) {
                                    setOwdLoading(true);
                                    const days = Number(
                                      repeatEmails
                                        .find((param: any) => param.Key === "owdDateDefault")
                                      ["Value"].trim(),
                                    );
                                    addItemRequest({
                                      listName: notificationIdsListName,
                                      body: { Title: "OWD" },
                                      updateReducer: false,
                                    }).then((notificationID) => {
                                      addItemRequest({
                                        listName: notificationsCardListName, body: {
                                          Title: "Уведомление " + notificationID,
                                          NotificationID: notificationID,
                                          Employee: currentUser.email,
                                          EmployeeEmail: currentUser.email,
                                          Document: card.ID,
                                          DocumentCode: `${card.Code}.${card.Index}`,
                                          ReviewDate: moment().add(days, 'days').toDate(),
                                          NotificationType: notificationStatuses.OWD,
                                          AuthorEmail: currentUser.email,
                                        }
                                      }).then((resultId: any) => {
                                        const newSearchParams = new URLSearchParams(query);
                                        newSearchParams.set("notificationCard", resultId.toString());
                                        setQuery(newSearchParams);
                                        setOwdLoading(false);
                                        navigate(0);
                                      });
                                    });
                                  }
                                  if (viewOwd) {
                                    const newSearchParams = new URLSearchParams(query);
                                    newSearchParams.set("notificationCard", viewOwd.ID.toString());
                                    setQuery(newSearchParams);
                                  }
                                }}
                                className="flex w-6 h-6"
                              >
                                <OwdNotificationIcon />
                              </a>
                            </TooltipItem>
                          }
                          <TooltipItem
                            position="top-left"
                            tooltipsText={"Отправить уведомление"}
                          >
                            <NotificationSendButton
                              zIndex={100}
                              isIconOnly={true}
                              read={{ documents: true }}
                              changeActive={(active: "get" | "send") =>
                                setLocalItem("notification_active", active)
                              }
                              initialSubmit={{
                                documents: documentCardID
                                  ? new Map([
                                    [
                                      +documentCardID,
                                      {
                                        id: +documentCardID,
                                        code: {
                                          code: card.Code + "." + card.Index,
                                          name: card.Title,
                                        },
                                        publicationDate:
                                          card.PublicationDate,
                                      },
                                    ],
                                  ])
                                  : new Map(),
                                reviewDate: moment(new Date())
                                  .add(30, "day")
                                  .toDate(),
                                comment: "",
                                employees: new Map(),
                                test: {
                                  Questions: [],
                                  IsQuestionFormOpen: false,
                                  MinCorrectAnswersCount: 1,
                                },
                              }}
                            />
                          </TooltipItem>
                        </>
                      )}
                      {location.pathname.indexOf('/1/notification') === -1 &&
                        <TooltipItem position="top-left" tooltipsText={"Отчеты"}>
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              setReportDocument(true);
                            }}
                            className="flex w-6 h-6 hover:text-darkblue text-[#9CA3AF]"
                          >
                            <ReportIcon />
                          </a>
                        </TooltipItem>
                      }
                      <div className="flex">
                        <FavoriteButton
                          position="top-left"
                          isFavorite={{
                            state: isFavoriteCard,
                            id: favoriteDocument && favoriteDocument.ID,
                          }}
                          onToggle={toggleFavorite}
                        />
                      </div>
                      {(currentUser.isAdmin ||
                        (currentUser.isCollectionAdmin &&
                          currentUser.isCollectionAdmin.length > 0)) && (
                          <>
                            {((loadingPrint || versionLoading) && (
                              <FlexCol className="flex w-6 h-6">
                                <Loading />
                              </FlexCol>
                            )) || (
                                <TooltipItem
                                  position="top-left"
                                  tooltipsText={"Распечатать"}
                                >
                                  <a
                                    id="print_external"
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (
                                        documentFile.length > 0 &&
                                        documentFile.find((file: any) =>
                                          /\.(mp4|mpeg|avi)$/i.test(file.FileRef)
                                        )
                                      ) {
                                        setVideoFile(true);
                                      } else {
                                        printHandle();
                                      }
                                    }}
                                    className="flex w-6 h-6"
                                  >
                                    <PrinterIcon />
                                  </a>
                                </TooltipItem>
                              )}
                            {(currentUser.isAdmin || (currentUser.isCollectionAdmin &&
                              currentUser.isCollectionAdmin.find(
                                (collectionID: any) =>
                                  collectionID === card.Collection.get_lookupId()
                              ))) && (
                                <>
                                  {(loadingArchive && (
                                    <FlexCol className="flex w-6 h-6">
                                      <Loading />
                                    </FlexCol>
                                  )) || (
                                      <TooltipItem
                                        position="top-left"
                                        tooltipsText={"Архивировать"}
                                      >
                                        {((versionsDocument.find(
                                          (version: any) =>
                                            version.Status.get_lookupId() ===
                                            docStatuses.approval
                                        ) ||
                                          versionsDocument.find(
                                            (version: any) =>
                                              version.Status.get_lookupId() ===
                                              docStatuses.revision
                                          ) ||
                                          versionsDocument.find(
                                            (version: any) =>
                                              version.Status.get_lookupId() ===
                                              docStatuses.cancel
                                          )) && (
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                localStorage.setItem(
                                                  "noAddArchive",
                                                  "true"
                                                );
                                                setSendApproveBlock(true);
                                              }}
                                              className="flex w-6 h-6"
                                            >
                                              <ArchiveAddIcon />
                                            </a>
                                          )) || (
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setArchiveConfirm(true);
                                              }}
                                              className="flex w-6 h-6"
                                            >
                                              <ArchiveAddIcon />
                                            </a>
                                          )}
                                      </TooltipItem>
                                    )}
                                </>
                              )}
                          </>
                        )}
                    </>
                  )}
                </>
              )}
            {/* Если статус в архиве */}
            {activeTabKey === "card" &&
              card &&
              card.Status.get_lookupId() === docStatuses.archive && (
                <>
                  {!hideCloseIcon && (
                    <>
                      <TooltipItem
                        position="top-left"
                        tooltipsText={"Разархивировать"}
                      >
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            archiveEndHandle();
                          }}
                          className="flex w-6 h-6"
                        >
                          <ArchiveIcon />
                        </a>
                      </TooltipItem>
                      {currentUser.isAdmin &&
                        <TooltipItem position="top-left" tooltipsText={"Удалить"}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setRemoveDocument(true);
                            }}
                            className="flex w-6 h-6"
                          >
                            <TrashIcon />
                          </a>
                        </TooltipItem>
                      }
                    </>
                  )}
                </>
              )}
          </span>
        </div>
        {(customLoading) &&
          <FlexCol className="items-center justify-center w-full">
            <span className="block mb-5 text-base text-darkblue">
              Идет обработка данных.
              <br />
              Пожалуйста подождите...
            </span>
            <Loading />
          </FlexCol>
          || (
            <>
              {!hideCloseIcon && card && (
                <TabsCard
                  card={card}
                  documentCardID={documentCardID}
                  versionView={versionView}
                  activeTabKey={activeTabKey}
                  setActiveTabKey={setActiveTabKey}
                />
              )}
              {activeTabKey === "card" && (
                <>
                  <Card
                    setIdRemoveElem={setIdRemoveElem}
                    documentCardID={documentCardID}
                    formData={formData}
                    setUpdateCardData={setUpdateCardData}
                    setFormData={setFormData}
                    setOpenCancelAddCard={setOpenCancelAddCard}
                    openCancelAddCard={openCancelAddCard}
                    setApproversCardDocumentData={setApproversCardDocumentData}
                    versionView={versionView}
                    setHideCloseIcon={setHideCloseIcon}
                    showEditApprovers={showEditApprovers}
                    setShowEditApprovers={setShowEditApprovers}
                    sendApproveBlock={sendApproveBlock}
                    setSendApproveBlock={setSendApproveBlock}
                    setRemoveDocument={setRemoveDocument}
                    removeDocument={removeDocument}
                    card={card}
                    setCard={setCard}
                    setImagesDoc={setImagesDoc}
                    removeObjData={removeObjData}
                  />
                  {card &&
                    (card.Status.get_lookupId() === docStatuses.public ||
                      card.Status.get_lookupId() === docStatuses.review) &&
                    versionView && (
                      <>
                        {((versionsDocument.find(
                          (version: any) =>
                            version.Status.get_lookupId() === docStatuses.approval
                        ) ||
                          versionsDocument.find(
                            (version: any) =>
                              version.Status.get_lookupId() === docStatuses.revision
                          ) ||
                          versionsDocument.find(
                            (version: any) =>
                              version.Status.get_lookupId() === docStatuses.cancel
                          )) && (
                            <SupplayButton
                              open={sendApproveBlock}
                              setOpen={setSendApproveBlock}
                              classBg="btn-white"
                              icon={true}
                              typeIcon="return"
                              shadow={true}
                              text="Вернуть в работу"
                            />
                          )) || (
                            <SupplayButton
                              open={openReturnToWork}
                              setOpen={setOpenReturnToWork}
                              classBg="btn-white"
                              icon={true}
                              typeIcon="return"
                              shadow={true}
                              text="Вернуть в работу"
                              customFunction={checkReturnToWork}
                              paramsCustomFunction={card.ID}
                            />
                          )}
                      </>
                    )}
                </>
              )}
              {activeTabKey === "approvers" && (
                <>
                  <ApproversCard
                    versionView={versionView}
                    documentCardID={documentCardID}
                    card={card}
                    approversList={approversList}
                  />
                  {!_.isEmpty(card) &&
                    (card.Status.ID === docStatuses.public ||
                      card.Status.ID === docStatuses.review) &&
                    versionView && (
                      <>
                        {((versionsDocument.find(
                          (version: any) =>
                            version.Status.ID === docStatuses.approval
                        ) ||
                          versionsDocument.find(
                            (version: any) =>
                              version.Status.ID === docStatuses.revision
                          ) ||
                          versionsDocument.find(
                            (version: any) =>
                              version.Status.ID === docStatuses.cancel
                          )) && (
                            <SupplayButton
                              open={sendApproveBlock}
                              setOpen={setSendApproveBlock}
                              classBg="btn-white"
                              icon={true}
                              typeIcon="return"
                              shadow={true}
                              text="Вернуть в работу"
                            />
                          )) || (
                            <SupplayButton
                              open={openReturnToWork}
                              setOpen={setOpenReturnToWork}
                              classBg="btn-white"
                              icon={true}
                              typeIcon="return"
                              shadow={true}
                              text="Вернуть в работу"
                              customFunction={checkReturnToWork}
                              paramsCustomFunction={card.ID}
                            />
                          )}
                      </>
                    )}
                </>
              )}
              {activeTabKey === "history" && (
                <>
                  <HistoryCard
                    versionView={versionView}
                    documentCardID={documentCardID}
                  />
                  {!_.isEmpty(card) &&
                    (card.Status.ID === docStatuses.public ||
                      card.Status.ID === docStatuses.review) &&
                    versionView && (
                      <>
                        {((versionsDocument.find(
                          (version: any) =>
                            version.Status.ID === docStatuses.approval
                        ) ||
                          versionsDocument.find(
                            (version: any) =>
                              version.Status.ID === docStatuses.revision
                          ) ||
                          versionsDocument.find(
                            (version: any) =>
                              version.Status.ID === docStatuses.cancel
                          )) && (
                            <SupplayButton
                              open={sendApproveBlock}
                              setOpen={setSendApproveBlock}
                              classBg="btn-white"
                              icon={true}
                              typeIcon="return"
                              shadow={true}
                              text="Вернуть в работу"
                            />
                          )) || (
                            <SupplayButton
                              open={openReturnToWork}
                              setOpen={setOpenReturnToWork}
                              classBg="btn-white"
                              icon={true}
                              typeIcon="return"
                              shadow={true}
                              text="Вернуть в работу"
                              customFunction={checkReturnToWork}
                              paramsCustomFunction={card.ID}
                            />
                          )}
                      </>
                    )}
                </>
              )}
              {activeTabKey === "versions" && (
                <VersionsCard
                  documentCardID={documentCardID}
                  versionView={versionView}
                />
              )}
              {activeTabKey === "copies" && (
                <CopiesCard
                  documentCardID={documentCardID}
                  versionView={versionView}
                />
              )}
              {activeTabKey === "lists" && (
                <ListsCard
                  setIdRemoveElem={setIdRemoveElem}
                  documentCardID={documentCardID}
                />
              )}
            </>
          )}
      </div>
      {showEditApprovers && (
        <EditApproversModal
          setOpen={setShowEditApprovers}
          dialogToggle={dialogToggleEditApprovers}
          open={showEditApprovers}
          setApprovers={setApprovers}
          collection={
            (Object.keys(formData).length > 0 && formData.Collection["id"]) ||
            card.Collection.get_lookupId()
          }
          typeDocument={
            (Object.keys(formData).length > 0 && formData.DocType["id"]) ||
            card.DocType.get_lookupId()
          }
          updateCardData={updateCardData}
          setApproversCardDocumentData={setApproversCardDocumentData}
          setShowEditApprovers={setShowEditApprovers}
          approversList={approversList}
          versionView={versionView}
          card={card}
        />
      )}
      {showConfirmChangeStatus && (
        <ConfirmChangeStatusCardModal
          setOpen={setShowConfirmChangeStatus}
          open={showConfirmChangeStatus}
          dialogToggle={dialogToggleConfirmChangeStatus}
          dataSend={approversCardDocumentData}
          removeObjData={removeObjData}
          versionView={versionView}
          setCustomLoading={setCustomLoading}
        />
      )}
      {showConfirmRemove && (
        <ConfirmRemoveModal
          setOpen={setShowConfirmRemove}
          open={showConfirmRemove}
          dialogToggle={dialogToggleConfirmRemove}
          removeData={idRemoveElem}
        />
      )}
      {openCancelAddCard && (
        <CancelAddCard
          open={openCancelAddCard}
          toggleDialog={dialogToggleCancelAddCard}
          setOpen={setOpenCancelAddCard}
          setCloseAllModals={setCloseAllModals}
          closeAllModals={closeAllModals}
        />
      )}
      {sendApproveBlock && (
        <ApproveBlockModal
          open={sendApproveBlock}
          toggleDialog={dialogToggleApproveBlock}
          setOpen={setSendApproveBlock}
          setCloseAllModals={setCloseAllModals}
          closeAllModals={closeAllModals}
          card={card}
        />
      )}
      {openReturnToWork && (
        <ReturnToWorkModal
          open={openReturnToWork}
          toggleDialog={dialogToggleReturnToWork}
          setOpen={setOpenReturnToWork}
          setCloseAllModals={setCloseAllModals}
          closeAllModals={closeAllModals}
          versionView={versionView}
          showEditApprovers={showEditApprovers}
          setShowEditApprovers={setShowEditApprovers}
          card={card}
        />
      )}
      {archiveConfirm && (
        <ArchiveConfirmModal
          open={archiveConfirm}
          toggleDialog={dialogToggleArchiveConfirm}
          setOpen={setArchiveConfirm}
          setCloseAllModals={setCloseAllModals}
          closeAllModals={closeAllModals}
          setCustomLoading={setLoadingArchive}
          card={card}
          setCard={setCard}
        />
      )}
      {archiveEnd && (
        <ArchiveEndModal
          open={archiveEnd}
          toggleDialog={dialogToggleArchiveEnd}
          setOpen={setArchiveEnd}
          showEditApprovers={showEditApprovers}
          setShowEditApprovers={setShowEditApprovers}
          card={card}
        />
      )}
      {removeDocument && (
        <RemoveDocumentModal
          open={removeDocument}
          toggleDialog={dialogToggleRemoveDocument}
          setOpen={setRemoveDocument}
          versionView={versionView}
          card={card}
        />
      )}
      {reportDocument && (
        <ReportDocumentModal
          open={reportDocument}
          setQuery={setQuery}
          query={query}
          toggleDialog={dialogToggleReportDocument}
          setOpen={setReportDocument}
          versionView={versionView}
          card={card}
        />
      )}
      {location.pathname.indexOf('/1/notification') === -1 && ((reportDocument && query.has("notificationCard")) || (viewAudit && query.has("notificationCard")) || (viewOwd && query.has("notificationCard"))) && (
        <NotificationReportDrawer zIndex={110} customRole={viewOwd && query.has("notificationCard") && "get" || ""} />
      )}
      <Modal
        zIndex={110}
        modalClassName="min-h-px flex gap-5 p-10 max-w-[600px]"
        open={videoFile}
        toggleDialog={setVideoFile}
      >
        <h2 className="mb-2">Ошибка</h2>
        <p className="mb-10">Данный формат файла не может быть распечатан</p>
        <FlexRow className="w-full justify-center items-center">
          <TGButton onClick={() => setVideoFile(false)} color="bluedark">
            Закрыть
          </TGButton>
        </FlexRow>
      </Modal>
      <Modal
        zIndex={110}
        modalClassName="min-h-px flex gap-5 p-10"
        open={viewDocMode}
        toggleDialog={setViewDocMode}
      >
        <h2 className="mb-2">{card && card.Title}</h2>
        <ImagesList
          images={imagesDoc}
        />
        <FlexRow className="w-full justify-center items-center">
          <TGButton onClick={() => {
            setImagesDoc([]);
            setViewDocMode(false);
          }} color="bluedark">
            Закрыть
          </TGButton>
        </FlexRow>
      </Modal>
    </DialogComponent>
  );
};

export default DocumentCard;
